import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
} from "@aws-sdk/client-cognito-identity-provider";

const REGION = import.meta.env.VITE_COGNITO_REGION || "us-east-1";
const CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID || "";

const client = new CognitoIdentityProviderClient({ region: REGION });

export async function signIn(email, password) {
  const command = new InitiateAuthCommand({
    ClientId: CLIENT_ID,
    AuthFlow: "USER_PASSWORD_AUTH",
    AuthParameters: { USERNAME: email, PASSWORD: password },
  });
  const res = await client.send(command);
  if (!res.AuthenticationResult) {
    throw new Error(res.ChallengeName ? `추가 인증이 필요합니다 (${res.ChallengeName})` : "로그인에 실패했습니다.");
  }
  const t = res.AuthenticationResult;
  return {
    idToken: t.IdToken,
    refreshToken: t.RefreshToken,
    expiresAt: Date.now() + (t.ExpiresIn || 3600) * 1000,
  };
}

export async function refreshTokens(refreshToken) {
  const command = new InitiateAuthCommand({
    ClientId: CLIENT_ID,
    AuthFlow: "REFRESH_TOKEN_AUTH",
    AuthParameters: { REFRESH_TOKEN: refreshToken },
  });
  const res = await client.send(command);
  const t = res.AuthenticationResult;
  if (!t) throw new Error("세션 갱신에 실패했습니다.");
  return {
    idToken: t.IdToken,
    expiresAt: Date.now() + (t.ExpiresIn || 3600) * 1000,
  };
}
